import { useQuery } from '@tanstack/react-query';
import type { Project } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useProject(id: string | undefined) {
  return useQuery({
    queryKey: ['project', id],
    queryFn: () => apiGet<Project>(`/v1/projects/${id}`),
    enabled: !!id,
  });
}
